var styles = {"article":"TextButton-module_article__iQPUS","icon":"TextButton-module_icon__AToK6"};

export { styles as default };
